/** Words and formats used across the dashboard — English, the source of the other languages */
const common = {
  "common.justNow": "just now",
  "common.minutesAgo": "{count}m ago",
  "common.hoursAgo": "{count}h ago",
  "common.daysAgo": "{count}d ago",
  "common.duration.minutes": { one: "{count} minute", other: "{count} minutes" },
  "common.duration.hours": { one: "{count} hour", other: "{count} hours" },
  "common.duration.days": { one: "{count} day", other: "{count} days" },
  "common.duration.weeks": { one: "{count} week", other: "{count} weeks" },
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.continue": "Continue",
  "common.working": "Working",
  "common.loading": "Loading…",
  "common.tryAgain": "That did not work — try again",
  "common.tryAgainButton": "Try again",
  "common.retry": "Retry",
  "common.copy": "Copy",
  "common.download": "Download",
  "common.saved": "Saved",
  "common.notSaved": "Not saved",
  "common.couldNotCopy": "Could not copy",
  "common.goBack": "Go back",
  "common.password": "Password",
  "common.emailAddress": "Email address",
  "common.showPassword": "Show password",
  "common.hidePassword": "Hide password",
  "common.signOut": "Sign out",
  "common.notFoundTitle": "Page not found",
  "common.notFoundText": "The page you're looking for doesn't exist or you don't have access to it.",
  "common.errorTitle": "Something went wrong",
  "common.errorUnexpected": "An unexpected error occurred.",
  "common.loadFailed": "Failed to load data.",
  "common.showing": "Showing {start}–{end} of {total}",
  "common.previousPage": "Previous page",
  "common.nextPage": "Next page",
  "common.notifications": "Notifications",
  "common.dismiss": "Dismiss",
  "common.refresh": "Refresh",
  "common.viewAll": "View all",
  "common.view": "View",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.actions": "Actions",
  "common.status": "Status",
  "common.name": "Name",
  "common.description": "Description",
  "common.clients": "Clients",
  "common.devices": "Devices",
  "common.active": "Active",
  "common.disabled": "Disabled",
  "common.saveFailed": "Save failed",
  "common.internalError": "Internal server error",
  "common.clientsCount": { one: "{count} client", other: "{count} clients" },
  "common.devicesCount": { one: "{count} device", other: "{count} devices" },
  "common.onlineCount": "{count} online",
  "common.critical": { one: "{count} critical", other: "{count} critical" },
  "common.status.ONLINE": "ONLINE",
  "common.status.OFFLINE": "OFFLINE",
  "common.status.WARNING": "WARNING",
  "common.status.ERROR": "ERROR",
  "common.status.PENDING": "PENDING",
  "common.status.PENDING_VPN": "PENDING VPN",
  "common.status.PROVISIONING": "PROVISIONING",
  "common.status.ACTIVE": "ACTIVE",
  "common.status.INACTIVE": "INACTIVE",
  "common.status.COMPLETED": "COMPLETED",
  "common.status.RUNNING": "RUNNING",
  "common.status.FAILED": "FAILED",
  "common.status.EXPIRED": "EXPIRED",
  "common.status.SUSPENDED": "SUSPENDED",
  "common.status.DELETED": "DELETED",
  "common.status.FAILOVER": "FAILOVER",
  "common.status.APPLIED": "APPLIED",
  "common.status.UNSUPPORTED": "UNSUPPORTED",
  "common.select": "Select…",
  "common.selectAll": "Select all",
  "common.deselectAll": "Deselect all",
  "common.more": "+{count} more",
  "common.optional": "(optional)",
  "common.sitesCount": { one: "{count} site", other: "{count} sites" },
  "common.send": "Send",
  "common.uptime.days": "{d}d {h}h",
  "common.uptime.hours": "{h}h {m}m",
  "common.uptime.minutes": "{m}m",
  "common.copied": "Copied",
  "common.remove": "Remove",
  "common.saving": "Saving…",
  "common.username": "Username",
  "common.tryAgainMoment": "Try again in a moment.",
  "common.duration.seconds": { one: "{count} second", other: "{count} seconds" },
  "common.status.PENDING_SETUP": "BEING SET UP",
  "common.status.CANCELLED": "CANCELLED",
  "common.languageName.en": "English",
  "common.languageName.nl": "Dutch",
  "common.languageName.fr": "French",
  "common.languageName.de": "German",
  "common.languageName.es": "Spanish",
  "common.status.QUEUED": "SAVED FOR LATER",
  "common.status.DISCARDED": "DISCARDED",
  "common.renewCert.title": "Renew the VPN certificate of {name}?",
  "common.renewCert.titleMine": "Renew your VPN certificate?",
  "common.renewCert.stops": "The current certificate stops working at once: there is no VPN connection until the new file is installed.",
  "common.renewCert.remote": "A unit or controller that is only reached through the VPN can then not be reached from here: installing the new file may need someone on site.",
  "common.renewCert.noWayBack": "This cannot be undone: the old certificate cannot be used again.",
  "common.renewCert.continue": "I understand, continue",
  "common.renewCert.last": "Renew the certificate now? The current one stops working as soon as you click.",
  "common.renewCert.renewNow": "Renew now",
  "common.export.button": "Export",
  "common.export.title": "Export",
  "common.export.what": "What goes in",
  "common.export.summaryNone": "Everything shown",
  "common.export.rows": "Rows",
  "common.export.thisPage": "This page ({n})",
  "common.export.allMatches": "All matches ({n})",
  "common.export.tooMany": "More than 10 000 rows: export this page, or narrow the filters",
  "common.export.parts": "Parts",
  "common.export.format": "Format",
  "common.export.xlsx": "Spreadsheet (.xlsx)",
  "common.export.csv": "Spreadsheet (CSV)",
  "common.export.pdf": "PDF report",
  "common.export.md": "Markdown prompt for Claude Code",
  "common.export.go": "Export",
  "common.export.working": "Exporting…",
  "common.export.failed": "The export did not work",
  "common.export.search": "search “{q}”",
  "common.export.sortedBy": "sorted by {column}",
  "common.export.sortedByDesc": "sorted by {column}, descending",
  "common.export.field": "Field",
  "common.export.value": "Value",
  "common.export.deviceInfo": "Device info",
  "common.export.siteInfo": "Site info",
  "common.export.traffic": "Traffic",
  "common.export.cpu": "CPU",
  "common.export.serial": "Serial number",
  "common.export.mac": "MAC address",
  "common.export.level": "Level",
  "common.export.title_": "Title",
  "common.export.message": "Message",
  "common.export.time": "Time",
  "common.export.security": "Security",
  "common.export.band": "Band",
  "common.export.vlan": "VLAN",
  "common.export.ssid": "SSID",
  "common.export.enabled": "Enabled",
  "common.export.clientCount": "Clients",
  "common.export.period": "period {period}",
  "common.export.range": "{from} to {to}",
  "common.export.radios": "Radios",
  "common.export.modem": "Modem",
  "common.export.operator": "Operator",
  "common.export.network": "Network type",
  "common.export.events": "Events",
  "common.export.controller": "Controller",
  "common.export.wired": "Wired",
  "common.export.eventInfo": "Event info",
  "common.export.online": "Online and offline",
  "common.export.loads": "Out and back",
  "common.export.customer": "Customer",
  "common.export.resolvedAt": "Resolved",
  "common.export.loadedAt": "Loaded",
  "common.export.loadedBy": "Loaded by",
  "common.export.returnedAt": "Returned",
  "common.export.returnedBy": "Returned by",
  "common.export.figures": "Figures",
  "common.export.critical": "Critical",
  "common.export.vlans": "VLANs",
  "common.export.wifi": "WiFi",
  "common.export.kind": "Kind",
  "common.export.changedBy": "Changed by",
  "common.export.changedAt": "Changed at",
  "common.export.change": "Change",
  "common.export.articleInfo": "Article info",
  "common.export.when": "When",
  "common.export.copied": "Copied and downloaded",
  "common.export.downloadedOnly": "Downloaded (copying is not allowed here)",
  "common.export.twoFactor": "Two-factor sign-in",
  "common.export.systemRole": "System role",
  "common.export.type": "Type",
  "common.export.deviceFamily": "Device family",
  "common.export.origin": "Origin",
  "common.export.isDefault": "Default",
  "common.export.madeBy": "Made by",
  "common.export.created": "Created",
  "common.export.applied": "Times applied",
  "common.export.watches": "Watches",
  "common.export.channels": "Channels",
  "common.export.mutedDevices": "Muted devices",
  "common.export.who": "Who",
  "common.export.action": "Action",
  "common.export.resource": "Resource",
  "common.export.health": "Health",
  "common.export.goesTo": "Goes to",
  "common.export.checkedAt": "Checked",
  "common.export.times": "Times met",
  "common.export.exampleSite": "Example site",
  "common.export.noLimit": "No limit",
  "common.export.lastSeen": "Last seen",
  "common.export.simSlot": "SIM slot",
  "common.export.pinTries": "PIN tries left",
  "common.export.pukTries": "PUK tries left",
  "common.export.pinUsed": "PIN used",
  "common.export.storedPin": "Router's stored PIN matches",
  "common.export.readAt": "Read at",
  "common.export.sims": "SIM slots",
  "common.export.latency": "Latency (ms)",
  "common.export.loss": "Loss (%)",
  "common.export.peer": "Peer",
  "common.export.signal": "{name} (dBm)",
}

export default common
